import _ from "lodash";
import { getDispatch } from "reducers";
import ThetaGridPaginatedAg from "./thetaGridPaginatedAg";
import { useSelector } from "react-redux";
import { isLoadingEnabled } from "models/loaders/selectors";
import { triggerSynchronousAgGridLoading } from "../../models/dynamicGrid/sagaActions";
import { Dot9loader } from "molecules/dot9loader";
import { useEffect } from "react";
import { TConfig } from "models/dynamicGrid/types";

export type TProps = {
  parent?: any;
  config: TConfig;
  extendFilters?: React.FunctionComponent | HTMLElement | JSX.Element;
  isStorageEnabled?: boolean;
  offset?: number;
  rowIndex?: number;
  hasChildRows?: boolean;
  refreshTimestamp?: number;
  childCustomActions?: any;
  childCellRendererParams?: any;
  refreshChildGridData?: boolean;
  onDataRender?: (data: any) => void;
  onDomRef?: (ref: any) => void;
};

const ThetaGridPaginated = (props: TProps) => {

  const isLoadingMeta = useSelector((state) =>
    isLoadingEnabled(state, `agGridLoading/${props.config.tableId}`)
  );

  const dispatch = getDispatch();
  useEffect(() => {
    dispatch(
      triggerSynchronousAgGridLoading({
        tableId: props.config.tableId,
      })
    );
  }, [dispatch, props.config.tableId]);

  if (isLoadingMeta || isLoadingMeta === undefined) {
    return <Dot9loader />;
  }
  const agProps = _.pick(props, [
    "config",
    "extendFilters",
    "parent",
    "isStorageEnabled",
    "offset",
    "rowIndex",
    "hasChildRows",
    "refreshTimestamp",
    "childCustomActions",
    "childCellRendererParams",
    "refreshChildGridData",
  ]);
  return <ThetaGridPaginatedAg key={props.config.tableId} {...agProps} />;
};

export default ThetaGridPaginated;
